import { Box, Text, FormLabel } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../../../services/lang/lang';
export const NoInspectorsAssignedMessage = () => (React.createElement(Box, { "data-testid": "no_inspectors_assigned" },
    React.createElement(FormLabel, null, localise('ASSIGNED_INSPECTORS')),
    React.createElement(Text, { variant: "dk-800-rg-3" }, localise('NO_INSPECTORS_ASSIGNED'))));
